import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * このタブでアプリ内を遷移してきたかどうか。
 * React Router が history.state に持つ index（最初に開いた画面が 0、遷移するたびに +1）を読む。
 * ブックマーク・共有 URL・ログイン後の復帰で直接開いた画面は 0 で、履歴を戻るとアプリの外に出てしまう。
 */
export const hasInAppHistory = (state: unknown = window.history.state): boolean => {
  const idx = (state as { idx?: unknown } | null)?.idx;
  return typeof idx === 'number' && idx > 0;
};

/**
 * 「戻る」の遷移先を決める（docs/08-uiux-design.md U08）。
 * 直前の画面があればそこへ戻り、一覧の絞り込み・位置もそのまま復元される。
 * 直前の画面が無いときだけ fallback（その画面の親にあたる一覧）へ進む。
 */
export const useGoBack = (fallback: string) => {
  const navigate = useNavigate();
  return useCallback(() => {
    if (hasInAppHistory()) navigate(-1);
    else navigate(fallback);
  }, [navigate, fallback]);
};
